/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-19 16:29:09
 * @FilePath: src/store/getters.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
const getters = {
  // token获取
  token: (state) => state.user.token,
  // 用户名 工号
  name: (state) => state.user.userInfo?.userName,
  // 用户头像
  avatar: (state) => state.user.avatar,
  // 权限路由
  permissionRoutes: (state) => state.permission.routes,
  // 用户信息
  userInfo: (state) => state.user.userInfo,
  // 是否是管理员
  isAdmin: (state) => state.user.isAdmin,
  // 当前工作台
  currentWorkbench: (state) => state.app.currentWorkbench,
  // 用户角色
  roles: (state) => state.user.roles,
  dataList: state => state.app.dataList
}
export default getters
